import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/new/31.png';
import _imports_1 from '../../../assets/new/33.png';
import _imports_2 from '../../../assets/new/34.png';
import _imports_3 from '../../../assets/new/49.png';
import _imports_4 from '../../../assets/new/9.png';
import _imports_5 from '../../../assets/new/51.png';
const _withScopeId = n => (_pushScopeId("data-v-2e9784cb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  class: "main"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "请输入12位卡密进行充值", -1));
const _hoisted_6 = {
  class: "input"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_8 = {
  class: "num"
};
const _hoisted_9 = {
  class: "footer"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5
}, null, -1));
import { ref, onMounted, computed } from "vue";
import { Dialog } from "vant";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { getLocalPid } from "../../../libs/util";
import { bizRecharge, bizUrlStore } from "../../../api/index";
import { ElMessage } from "element-plus";
export default {
  __name: 'recharge_copy',
  setup(__props) {
    const isMobile = computed(() => {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let getArr = Agents.filter(i => userAgentInfo.includes(i));
      return getArr.length ? true : false;
    });
    const store = useStore();
    const router = useRouter();
    const safeMes = computed(() => store.state.safeMes);
    const card = ref("");
    const address = ref("");
    const recharge = () => {
      Dialog.confirm({
        message: "是否需要修改学校信息",
        "confirm-button-text": "修改",
        "cancel-button-text": "不修改"
      }).then(() => {
        router.push({
          name: "schoolMes"
        });
      }).catch(() => {
        let obj = {
          ...safeMes.value,
          cardNumber: card.value,
          pid: getLocalPid()
        };
        bizRecharge(encodeURIComponent(JSON.stringify(obj))).then(res => {
          let data = res.data;
          console.log(data);
          if (data.code) return store.commit("judgeCode", {
            code: data.code,
            msg: data.msg
          });
          if (data.data.cardType == "READING") {
            ElMessage.success("阅读服务 充值成功");
          } else if (data.data.cardType == "ONLINE_QA") {
            ElMessage.success("名师在线服务 充值成功");
          } else if (data.data.cardType == "READING_SPECIAL") {
            ElMessage.success("扩展阅读 充值成功");
          } else if (data.data.cardType == "HIPPO_A1_EXAM") {
            ElMessage.success("HIPPO A1考试 充值成功");
          } else {
            ElMessage.success("充值成功");
          }
          store.commit("destoryPreUserMes");
          card.value = "";
        }).catch(err => {
          console.log(err);
          return ElMessage.error("充值失败 请稍后再试");
        });
      });
    };
    const navToBuy = () => {
      window.location.href = address.value;
    };
    const getStoreAddress = () => {
      let obj = {
        ...safeMes.value,
        pid: getLocalPid()
      };
      console.log(obj);
      bizUrlStore(encodeURIComponent(JSON.stringify(obj))).then(res => {
        let data = res.data;
        if (data.code) return ElMessage.error(data.msg);
        address.value = data.data;
      }).catch(err => {
        console.log(err);
        return ElMessage.error("发生错误 获取商城地址失败");
      });
    };
    onMounted(() => {
      getStoreAddress();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([isMobile.value ? 'container' : 'containerPc'])
      }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).go(-1))
      }, _hoisted_3), _createTextVNode(" 会员充值 ")]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "请输入密码",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => card.value = $event),
        maxlength: "12"
      }, null, 512), [[_vModelText, card.value]]), _createElementVNode("img", {
        src: _imports_2,
        onClick: _cache[2] || (_cache[2] = $event => card.value = '')
      })]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(card.value.length), 1), _createTextVNode("/12 ")]), _createElementVNode("button", {
        type: "button",
        onClick: recharge
      }, "确定"), 1 === 2 && address.value ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: "javascript: void(0)",
        onClick: navToBuy
      }, "去学习商城购买卡密 >>")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[3] || (_cache[3] = $event => _unref(router).push({
          name: 'index',
          query: {
            pid: _ctx.pid
          }
        }))
      }, [_hoisted_10, _createTextVNode(" 原版阅读 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[4] || (_cache[4] = $event => _unref(router).push({
          name: 'photo',
          query: {
            pid: _unref(getLocalPid)()
          }
        }))
      }, [_hoisted_11, _createTextVNode(" AI工具 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        style: {
          "color": "#35b9ff"
        },
        onClick: _cache[5] || (_cache[5] = $event => _unref(router).push({
          name: 'my',
          query: {
            pid: _unref(getLocalPid)()
          }
        }))
      }, [_hoisted_12, _createTextVNode(" 个人中心 ")])])])], 2);
    };
  }
};